import React from 'react';
import Navbar from '../components/Navbar';
import './ProtectedPage.css';

const SettingsPage = () => {
    return (
        <div className="protected-page">
            <Navbar />
            <div className="page-content">
                <div className="page-header">
                    <h1 className="page-title">Settings</h1>
                    <p className="page-subtitle">Configure your account preferences</p>
                </div>

                <div className="page-card">
                    <p style={{ color: '#94a3b8', fontStyle: 'italic' }}>
                        Settings configuration coming soon. Only available for Enterprise Plans.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;
